import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../components/Button.css";
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Container,
  Table,
} from "react-bootstrap";
import "../formsList.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import SecurePageSection from "../../SecurePageSection";
import { LinkContainer } from "react-router-bootstrap";

const EminenceGrp4List = () => {
  const user = useSelector((state) => state.authentication.user);

  const [forms, setForms] = useState([]);

  const fetchForms = async () => {
    const response = await axios.get(`/api/forms/ventures/eminence-4-groups/`);
    console.log(response.data);
    setForms(response.data);
  };

  const navigate = useNavigate();

  useEffect(() => {
    fetchForms();
  }, []);

  return (
    <div>
      <Container className="body">
        <Col lg={8}>
          <h2>Eminence 4 (Groups)</h2>
        </Col>

        <Table responsive="md" striped bordered>
          <thead className="tableHead">
            <tr>
              <th>S. No.</th>
              <th>Form Id</th>
              <th>Group Name</th>
              <th>Region Name</th>
              <th>Submitted By</th>
              {(() => {
                if (
                  (typeof user !== "undefined" &&
                    typeof user.username !== "undefined" &&
                    user.accessGroup === "admin") ||
                  (typeof user !== "undefined" &&
                    typeof user.username !== "undefined" &&
                    user.accessGroup === "eminenceChair")
                ) {
                  return <th>Form</th>;
                }
              })()}
            </tr>
          </thead>

          <tbody className="tableBody">
            {forms
              .slice(0)
              .reverse()
              .map((form, index) => (
                <tr
                  key={index}
                  style={{ textTransform: "capitalize", textAlign: "center" }}
                >
                  <td>{index + 1}</td>
                  <td>{form.id}</td>
                  <td>{form.grpName}</td>
                  <td>{form.regName}</td>
                  <td>{form.name}</td>

                  <td style={{ width: "20rem" }}>
                    <Row>
                      <Col>
                        <div style={{ textTransform: "center" }}>
                          <LinkContainer to={`/eminence/4/response/${form.id}`}>
                            <Button variant="light" className="btn--four">
                              View Form
                            </Button>
                          </LinkContainer>
                        </div>
                      </Col>
                    </Row>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </div>
  );
};

export default EminenceGrp4List;
